export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 80,
    slots: {
      default: 'opt',
    },
  },
  {
    headerAlign: 'center',
    field: 'custStatementNo',
    align: 'center',
    fixed: 'left',
    width: 160,
    title: '客户账单编号',
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    slots: {
      default: 'custStatementNo',
    },
  },
  {
    headerAlign: 'center',
    field: 'custName',
    align: 'left',
    minWidth: 200,
    title: '客户名称',
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'incomeAmount',
    align: 'center',
    minWidth: 120,
    title: '应收运费',
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'incomeCostAmount',
    align: 'center',
    minWidth: 120,
    title: '应收费用',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'incomeTotalAmount',
    align: 'center',
    minWidth: 120,
    title: '应收合计',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'beginDate',
    align: 'center',
    minWidth: 120,
    title: '账单开始日期',
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'endDate',
    align: 'center',
    minWidth: 120,
    title: '账单结束日期',
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'remark',
    align: 'left',
    minWidth: 150,
    title: '账单说明',
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    align: 'center',
    width: 100,
    title: '账单状态',
    slots: { default: 'status' },
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'createByName',
    title: '创建人',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'createTime',
    title: '创建时间',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'modifyByName',
    title: '修改人',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'modifyTime',
    title: '修改时间',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
